<template>
  <vue-google-autocomplete
    ref="address"
    id="map"
    classname="form-control"
    :placeholder="placeholder"
    v-on:placechanged="onAddressChange"
  >
  </vue-google-autocomplete>
</template>

<script>
// Servicios de google
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  props: {
    placeholder: String
  },
  components: {
    VueGoogleAutocomplete
  },
  methods: {
    onAddressChange: function(addressData) {
      this.$emit("address", addressData);
    }
  }
};
</script>

<style scoped>
.form-control {
  border-radius: 25px;
  color: var(--v-content-base);
  border: var(--v-content-base) 2px solid;
  padding-left: 2.5vh !important;
  padding-right: 2.5vh !important;
  min-height: 6vh;
  width: 100%;
  outline: none;
}
</style>
